// extracted by mini-css-extract-plugin
export default {"date":"ComparisonSectionTitle-module_date__umv1d","title":"ComparisonSectionTitle-module_title__tKlAd"};